/**
 * 목업 데이터.
 *
 * 토큰이 없을 때(브라우저 미리보기) 화면을 그리기 위한 데이터입니다.
 * 토큰이 있으면 api/ 아래의 fetch 계층이 대신 씁니다 — 실패해도 이것으로
 * 갈아치우지 않습니다. 빈 화면과 이유가 가짜 데이터보다 낫습니다.
 */
import type { PrayerNote } from './domain.ts';

export const me = { name: '강성민' };

export const notes: PrayerNote[] = [
  {
    id: 'n1',
    title: '이직 준비 — 최종 면접',
    body: '두 회사 사이에서 흔들리지 않게 하시고, 면접 자리에서 정직하게 답하게 하소서.',
    category: '개인',
    status: 'IN_PROGRESS',
    priority: 'URGENT',
    plan: { type: 'DATE', date: '2026-08-04' },
    representative: true,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-07-02',
    updatedAt: '2026-07-16',
  },
  {
    id: 'n2',
    title: '어머니 수술 회복',
    body: '수술 후 회복이 더디지 않게 하시고, 통증 가운데도 평안을 주소서.',
    category: '지인',
    status: 'PRAYING',
    priority: 'URGENT',
    plan: { type: 'DATE', date: '2026-07-31' },
    representative: true,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-07-10',
    updatedAt: '2026-07-28',
  },
  {
    id: 'n3',
    title: '수련회 인도자 준비',
    body: '맡겨진 자리에서 준비를 게을리하지 않게 하시고, 말씀 앞에 먼저 서게 하소서.',
    category: '교회',
    status: 'PRAYING',
    priority: 'IMPORTANT',
    plan: { type: 'DATE', date: '2026-08-07' },
    representative: false,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-06-28',
    updatedAt: '2026-07-20',
  },
  {
    id: 'n4',
    title: '지우 자격증 시험',
    body: '준비한 만큼 실력을 발휘하게 하시고, 결과보다 과정에서 배우게 하소서.',
    category: '지인',
    status: 'PRAYING',
    priority: 'NORMAL',
    plan: { type: 'DATE', date: '2026-08-11' },
    representative: false,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-07-05',
    updatedAt: '2026-07-05',
  },
  {
    id: 'n5',
    title: '새벽예배 꾸준히 나가기',
    body: '이번 학기 동안 주 3회 이상 새벽예배에 참석하게 하시고, 일찍 잠들 수 있도록 저녁 시간을 지켜 주소서.',
    category: '개인',
    status: 'PRAYING',
    priority: 'NORMAL',
    plan: { type: 'EVERYDAY' },
    representative: false,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-03-02',
    updatedAt: '2026-07-21',
  },
  {
    id: 'n6',
    title: '팀 이동 후 관계 회복',
    body: '새 팀에서 마음을 열게 하시고, 오해가 쌓이지 않게 하소서.',
    category: '사회',
    status: 'PARTIAL',
    priority: 'NORMAL',
    plan: { type: 'EVERYDAY' },
    representative: false,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-05-14',
    updatedAt: '2026-07-18',
  },
  {
    id: 'n7',
    title: '말씀 묵상 습관 세우기',
    body: '하루 한 장이라도 거르지 않게 하소서.',
    category: '개인',
    status: 'PARTIAL',
    priority: 'NORMAL',
    plan: { type: 'DATE', date: '2026-07-18' },
    representative: false,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-04-01',
    updatedAt: '2026-07-18',
  },
  {
    id: 'n8',
    title: '두려움 없이 기도 인도하기',
    body: '사람 앞이 아니라 주님 앞에서 기도하게 하소서.',
    category: '개인',
    status: 'ANSWERED',
    priority: 'NORMAL',
    plan: { type: 'EVERYDAY' },
    representative: false,
    isPrivate: false,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-02-11',
    updatedAt: '2026-06-30',
  },
  {
    id: 'n9',
    title: '아버지 검사 결과',
    body: '결과 앞에서 마음이 무너지지 않게 하소서.',
    category: '가정',
    status: 'PRAYING',
    priority: 'IMPORTANT',
    plan: { type: 'DATE', date: '2026-12-24' },
    representative: false,
    isPrivate: true,
    progress: [],
    history: [],
    author: '강성민',
    createdAt: '2026-08-20',
    updatedAt: '2026-08-25',
  },
];

/** 기도 진행 기록 — 사용자가 직접 쌓는 타임라인 (기획서 3.2.1) */
export const progress: Record<string, { label: string; date: string }[]> = {
  n1: [
    { label: '서류 지원', date: '2026-07-02' },
    { label: '1차 합격', date: '2026-07-16' },
    { label: '최종 면접', date: '2026-08-04' },
  ],
};

/** 기도 히스토리 — 시스템이 자동으로 쌓는 변경 로그 (기획서 3.2.1) */
export const history: Record<string, { date: string; what: string }[]> = {
  n1: [
    { date: '07/02', what: '생성' },
    { date: '07/09', what: '내용 수정' },
    { date: '07/16', what: '상태 변경 · 기도중 → 진행중' },
    { date: '07/16', what: '중요도 변경 · 중요 → 긴급' },
  ],
};

/** 특정 모임에서 올라온 기도 노트 (Home 대쉬보드의 '특정 모임' 카드용) */
export const roomNotes = [
  { id: 'rn1', roomName: '청년 3순', title: '7월 넷째 주 결단 기도', meta: '7/26 · 6명 참여' },
];
